import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";

const Edit = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  // const [location, setLocation] = useState({});
  const [factory, setFactory] = useState([]);
  // const [department, setDepartment] = useState({});
  const [product, setProduct] = useState([]);
  // const [unit, setUnit] = useState({});
  const [selectedFile, setSelectedFile] = useState({});
  const [isSelected, setIsSelected] = useState(false);
  const [list, setList] = useState([]);
  const [vendor, setVendor] = useState({});
  const [attachment, setAttachment] = useState({});
  const [error, setError] = useState({});
  const [url, setUrl] = useState(Http.getUri());
  const [products, setProducts] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedFactoryOption, setSelectedFactoryOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vendorsList, setVendorsList] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [otherExpenses, setOtherExpenses] = useState(0);

  const totalSubtotal = list.reduce((total, item) => {
    const totalSubtotal =
      (parseFloat(item.qty) || 0) * (parseFloat(item.price) || 0);
    const finalPrice =
      totalSubtotal +
      (parseFloat(item.damage_qty) || 0) * (parseFloat(item.deduction) || 0);
    return total + finalPrice;
  }, 0);

useEffect(() => {
  const calculatedDiscountAmount = discount;

  setDiscountAmount(calculatedDiscountAmount.toFixed(2));

  const calculatedTotalPayable =
    totalSubtotal -
    calculatedDiscountAmount +
    otherExpenses;

  setTotalPayableAmount(
    calculatedTotalPayable.toFixed(2)
  );
}, [totalSubtotal, discount, otherExpenses]);

  const handleDiscountChange = (e) => {
    const discount = parseFloat(e.target.value) || 0;
    setDiscount(discount);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleFileChange = (e) => {
    const fileArray = [];
    const files = e.target.files;
    Object.keys(files).forEach((key) => {
      fileArray.push(e.target.files[key]);
    });
    setSelectedFile(fileArray);
    setIsSelected(true);
  };

  // Set Experience State
  const handleInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };


  const fetchData = async () => {
    setLoading(true);

    try {
      const vendorRes = await Http.get("/vendor");
      setVendor(vendorRes.data);

      const options = vendorRes.data.map((vendor) => ({
        value: vendor.id,
        label: vendor.name,
      }));
      setVendorsList(options);

      const factoryRes = await Http.get("/factorySelect2");
      setFactory(factoryRes.data);

      const res3 = await Http.get("/product");
      setProducts(res3.data);
      const productOptions = res3.data.map((product) => ({
        value: product.id,
        label: product.name,
      }));
      setProduct(productOptions);

      const othersReceiveRes = await Http.get(
        "/others-receive/" + id + "/edit"
      );
      setInputs({
        date: othersReceiveRes.data.date,
        receipt_no: othersReceiveRes.data.receipt_no,
        vendor_id: othersReceiveRes.data.vendor_id,
        company_location_id: othersReceiveRes.data.company_location_id,
        department_id: othersReceiveRes.data.department_id,
        description: othersReceiveRes.data.description,
        status: othersReceiveRes.data.status,
        vendor: othersReceiveRes?.data?.vendor_id,
        factory_id: othersReceiveRes?.data?.factory_id,
        bill_no: othersReceiveRes?.data?.bill_no,
      });

      // Set discount if it exists in the response
      if (othersReceiveRes.data.discount) {
        setDiscount(parseFloat(othersReceiveRes.data.discount) || 0);
      }
      if (othersReceiveRes.data.other_expense) {
        setOtherExpenses(parseFloat(othersReceiveRes.data.other_expense) || 0);
      }

      const listInfo = [];
      Object.keys(othersReceiveRes.data.items).forEach((key) => {
        listInfo.push({
          id: othersReceiveRes.data.items[key].id, // Include item ID for updates
          product_id: othersReceiveRes.data.items[key].product_id,
          qty: othersReceiveRes.data.items[key].qty,
          price: othersReceiveRes.data.items[key].unit_price ?? 0,
          desc: othersReceiveRes.data.items[key].desc,
          deduction: othersReceiveRes.data.items[key].deduction,
          damage_qty: othersReceiveRes.data.items[key].damage_qty,
        });
      });
      setList(listInfo);

      setSelectedFactoryOption({
        label: othersReceiveRes.data.factory.name,
        value: othersReceiveRes.data.factory.id,
      });

      const attachmentInfo = [];
      Object.keys(othersReceiveRes.data.attachment).forEach((key) => {
        attachmentInfo.push({
          name: othersReceiveRes.data.attachment[key].attachment,
        });
      });
      setAttachment(attachmentInfo);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const splitUrl = url.split("/");
    let fullUrl = "";
    for (let i = 0; i < splitUrl.length - 1; i++) {
      fullUrl += splitUrl[i] + "/";
    }
    setUrl(fullUrl);
  }, []);

  const selectHandleChange = (selectedOption, actionMeta) => {
    if (actionMeta.name === "factory_id") {
      setSelectedFactoryOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }

    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Add More List
  const addMoreList = () => {
    setList([...list, { product_id: "", unit_id: "", qty: "", desc: "" }]); // Add One More List
  };
  // Remove List
  const removeList = (index) => {
    const inputInfo = [...list]; // Load All Existing experience State Data
    inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
    setList(inputInfo); // Replace Existing experience into State
  };
  const handleOtherExpensesChange = (e) => {
    const otherExpenses = parseFloat(e.target.value) || 0;
    setOtherExpenses(otherExpenses);
  };
  const formSubmit = () => {
    const listArr = [];
    Object.keys(list).forEach((key) => {
      listArr.push(list[key]);
    });

    inputs.file = selectedFile;
    inputs.items = listArr;
    inputs.discount = discount;
    inputs.other_expenses = otherExpenses;

    Http.put("/others-receive/" + id, inputs)
      .then((res) => {
        navigate("/others-receive", {
          state: { message: res.data.message, type: res.data.type },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const selectHandleChangeAddMore = (selectedOption, actionMeta, index) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : null;
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;

    if (name === "product_id" && selectedOption) {
      const selectedProduct = products.find(
        (product) => product.id === selectedOption.value
      );
      if (selectedProduct && selectedProduct.price) {
        inputInfo[index]["price"] = selectedProduct.price;
      }
    }
    setList(inputInfo);
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Purchase</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Edit Purchase Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">Factory</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={
                        factory.find(
                          (item) => item.value == inputs.factory_id
                        ) || null
                      }
                      onChange={selectHandleChange}
                      name="factory_id"
                      options={factory}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg" style={{ zIndex: 999 }}>
                    <div className="form-group">
                      <label>Select Vendor</label>
                      <Select
                        options={vendorsList}
                        value={
                          vendorsList.find(
                            (item) => item.value == inputs.vendor_id
                          ) || null
                        }
                        onChange={selectHandleChange}
                        name="vendor_id"
                        placeholder="Select Vendor"
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="col-lg">
                    <label>Bill No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="bill_no"
                      value={inputs.bill_no || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-10"></div>
                  <div className="col-2">
                    <button
                      className="btn btn-info btn-block mg-b-10"
                      onClick={addMoreList}
                    >
                      <i className="fa fa-plus mg-r-10"></i> ADD More
                    </button>
                  </div>
                  <table className="table table-sm align-items-center mb-0">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Product
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Qty
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Price <i className="fa fa-star required"></i>
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Subtotal
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Damage qty
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Deduction
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Subtotal
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Final Price
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Description
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from(list).map((x, i) => {
                        const subtotal =
                          (parseFloat(x.qty) || 0) * (parseFloat(x.price) || 0);
                        const deductionSubtotal =
                          (parseFloat(x.damage_qty) || 0) *
                          (parseFloat(x.deduction) || 0);
                        const finalPrice =
                          subtotal +
                          (parseFloat(x.damage_qty) || 0) *
                            (parseFloat(x.deduction) || 0);
                        return (
                          <tr key={i}>
                            <td>
                              <Select
                                options={product}
                                value={
                                  product.find(
                                    (item) => item.value === x.product_id
                                  ) || null
                                }
                                onChange={(selectedOption, actionMeta) =>
                                  selectHandleChangeAddMore(
                                    selectedOption,
                                    actionMeta,
                                    i
                                  )
                                }
                                name="product_id"
                                placeholder="Select Product"
                                isClearable
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                name="qty"
                                value={x.qty || ""}
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                name="price"
                                value={x.price || ""}
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </td>
                            <td align="right">
                              <div className="form-control-plaintext font-weight-bold">
                                {subtotal.toFixed(2)}
                              </div>
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                name="damage_qty"
                                value={x.damage_qty || ""}
                                placeholder="Damage qty"
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                name="deduction"
                                value={x.deduction || ""}
                                placeholder="deduction"
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </td>
                            <td align="right">
                              <div className="form-control-plaintext font-weight-bold">
                                {deductionSubtotal.toFixed(2)}
                              </div>
                            </td>
                            <td align="right">
                              <div className="form-control-plaintext font-weight-bold text-success">
                                {finalPrice.toFixed(2)}
                              </div>
                            </td>
                            <td>
                              <textarea
                                className="form-control"
                                name="desc"
                                value={x.desc || ""}
                                onChange={(e) => handleInputChange(e, i)}
                              ></textarea>
                            </td>
                            <td>
                              {list.length > 1 ? (
                                <button
                                  className="btn btn-danger btn-sm btn-block"
                                  onClick={() => removeList(i)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="table-active">
                        <td colSpan="3" className="text-right font-weight-bold">
                          Total Price:
                        </td>
                        <td className="font-weight-bold " align="right">
                          {list
                            .reduce((total, item) => {
                              const subtotal =
                                (parseFloat(item.qty) || 0) *
                                (parseFloat(item.price) || 0);
                              return total + subtotal;
                            }, 0)
                            .toFixed(2)}
                        </td>
                        <td colSpan="2"></td>
                        <td className="font-weight-bold" align="right">
                          {list
                            .reduce((total, item) => {
                              const subtotal =
                                (parseFloat(item.damage_qty) || 0) *
                                (parseFloat(item.deduction) || 0);
                              return total + subtotal;
                            }, 0)
                            .toFixed(2)}
                        </td>
                        {/* Final Total */}
                        <td
                          align="right"
                          className="font-weight-bold text-success"
                        >
                          {list
                            .reduce((total, item) => {
                              const subtotal =
                                (parseFloat(item.qty) || 0) *
                                (parseFloat(item.price) || 0);
                              const finalPrice =
                                subtotal +
                                (parseFloat(item.damage_qty) || 0) *
                                  (parseFloat(item.deduction) || 0);
                              return total + finalPrice;
                            }, 0)
                            .toFixed(2)}
                        </td>
                        <td colSpan="2"></td>
                      </tr>
                      <tr className="table-active">
                        <td
                          colSpan="5"
                          className="text-right font-weight-bold text-danger"
                        >
                          Discount Amount:
                        </td>
                        <td
                          colSpan="2"
                          className="font-weight-bold"
                          align="center"
                        >
                          <input
                            type="number"
                            className="form-control"
                            value={discount}
                            onChange={handleDiscountChange}
                            placeholder="Enter discount amount"
                          />
                        </td>
                        <td
                          className="font-weight-bold text-danger"
                          align="right"
                        >
                          {discountAmount}
                        </td>
                        <td colSpan="2"></td>
                      </tr>
                       <tr className="table-active">
                          <td
                            colSpan="5"
                            className="text-right font-weight-bold text-danger"
                          >
                            Other Expenses:
                          </td>
                          <td
                            colSpan="2"
                            className="font-weight-bold"
                            align="center"
                          >
                            <input
                              type="number"
                              className="form-control"
                              value={otherExpenses}
                              onChange={handleOtherExpensesChange}
                              placeholder="Enter other expenses"
                            />
                          </td>
                          <td
                            className="font-weight-bold text-danger"
                            align="right"
                          >
                            {otherExpenses.toFixed(2)}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                      <tr className="table-active">
                        <td colSpan="7" className="text-right font-weight-bold">
                          Total payable Amount:
                        </td>
                        <td className="font-weight-bold" align="right">
                          {totalPayableAmount}
                        </td>
                        <td colSpan="2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* <div className="row mt-3">
              <div className="col-lg">
                <label>Attachment</label>
                <input
                  type="file"
                  name="attachment"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
                {Array.from(attachment).map((x, i) => (
                  <a
                    href={url + "circular/" + x.name}
                    target="_blank"
                    className="btn btn-info"
                    style={{ marginRight: "10px", marginTop: "10px" }}
                  >
                    Download
                  </a>
                ))}
              </div>
            </div> */}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;